module.exports = __webpack_public_path__ + "static/media/BrixSans-Bold.a246f1f4.eot";